import {
  Columns,
  Column,
  Stack,
  Box,
  Bleed,
  Inline,
} from 'braid-design-system';
import type { FC } from 'react';

import { Display } from 'src/libs/Display';

import * as styles from './styles.css';

export interface TableRowLayoutProps {
  avatar: JSX.Element;
  name: JSX.Element;
  manuallyAdded: JSX.Element | null;
  phoneNumber: JSX.Element | null;
  status: JSX.Element;
  mostRecentRole: JSX.Element;
  mostRecentCompanyName: JSX.Element | null;
  mostRecentRoleMobile: JSX.Element;
  mostRecentApplication: JSX.Element;
  relativeApplicationTime: JSX.Element;
  previousApplications: JSX.Element | null;
  actions: JSX.Element;
}

export const TableRowLayout: FC<TableRowLayoutProps> = ({
  avatar,
  name,
  manuallyAdded,
  phoneNumber,
  status,
  mostRecentRole,
  mostRecentCompanyName,
  mostRecentRoleMobile,
  mostRecentApplication,
  relativeApplicationTime,
  previousApplications,
  actions,
}) => (
  <Box
    paddingY="medium"
    paddingX={['none', 'medium']}
    className={[styles.mobileColumns]}
  >
    <Display mobile>{avatar}</Display>
    <Box className={styles.tableRowLayout}>
      <Columns
        space={['medium', 'small']}
        alignY={manuallyAdded ? 'top' : 'center'}
        align="left"
      >
        <Column width="content" hideBelow="tablet">
          {avatar}
        </Column>
        <Column>
          {/* FIXME: Turn this into a Stack when we upgrade to Braid v33 */}
          {manuallyAdded ? (
            <Box
              display="flex"
              flexDirection="column"
              className={styles.gap.xsmall}
            >
              {name}
              {phoneNumber}
              <Display tablet desktop>
                <Bleed bottom="small">{manuallyAdded}</Bleed>
              </Display>
            </Box>
          ) : (
            <Stack space="xsmall">
              {name}
              {phoneNumber}
            </Stack>
          )}
        </Column>
      </Columns>

      {/* Turn this into an Inline when Braid v33 */}
      <Box display="flex" alignItems="center" className={styles.gap.small}>
        {manuallyAdded ? <Display mobile>{manuallyAdded}</Display> : null}
        {status}
      </Box>

      <Display tablet desktop>
        <Stack space="xsmall">
          {mostRecentRole}
          {mostRecentCompanyName}
        </Stack>
      </Display>

      <Box display="flex" className={[styles.stack, styles.previousRoleGap]}>
        <Display mobile>{mostRecentRoleMobile}</Display>
        {mostRecentApplication}
        {relativeApplicationTime}
      </Box>

      <Display tablet desktop>
        <Inline space="none" align="right" alignY="center">
          {previousApplications}
        </Inline>
      </Display>

      <Box
        display="flex"
        alignItems="center"
        justifyContent={['flexStart', 'flexEnd']}
        className={styles.actionColumnGap}
      >
        {actions}
      </Box>
    </Box>
  </Box>
);
